module.exports = __webpack_public_path__ + "static/img/rotor.59db2646.png";